import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/asyncToGenerator";
import _extends from "@babel/runtime-corejs2/helpers/extends";
import _slicedToArray from "@babel/runtime-corejs2/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import AppSwitcherFooter from './AppSwitcherFooter';
import Header from './Header';
import NavMenuDivider from '../../NavMenuDivider';
import Product from './Product';
import { fetchProductsActivationInfo } from '../../../../../api/fetch-products-activation-info';
import { getLink } from '../links';
import { mockedFetchProductsActivationInfo } from '../../../../../api/mocks/fetch-products-activation-info';
import { PRODUCT_STATUS, generateInitialProductsStatus, generateStatusForAllProducts } from '../productsStatus';
export var AppSwitcherContent = function AppSwitcherContent(_ref) {
  var currentProduct = _ref.currentProduct,
      environment = _ref.environment,
      features = _ref.features,
      _onLinkClick = _ref.onLinkClick,
      products = _ref.products,
      swicusOrgId = _ref.swicusOrgId,
      inverted = _ref.inverted;

  var _useState = useState(generateInitialProductsStatus(currentProduct)),
      _useState2 = _slicedToArray(_useState, 2),
      productsStatus = _useState2[0],
      setProductsStatus = _useState2[1];

  useEffect(function () {
    if (swicusOrgId) {
      setProductsActivationInfo();
    }
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Header, {
    inverted: inverted
  }), /*#__PURE__*/React.createElement(NavMenuDivider, null), products.map(function (product) {
    var productStatus = productsStatus[product.id];
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: product.id
    }, /*#__PURE__*/React.createElement(Product, _extends({}, product, {
      url: getLink(currentProduct, environment, products, product.id, productsStatus, swicusOrgId),
      features: features,
      inverted: inverted,
      productStatus: productStatus,
      swicusOrgId: swicusOrgId,
      onLinkClick: function onLinkClick() {
        return _onLinkClick(product.id, productStatus);
      }
    })), /*#__PURE__*/React.createElement(NavMenuDivider, null));
  }), /*#__PURE__*/React.createElement(AppSwitcherFooter, {
    onLinkClick: function onLinkClick() {
      return _onLinkClick();
    }
  }));

  function setProductsActivationInfo() {
    return _setProductsActivationInfo.apply(this, arguments);
  }

  function _setProductsActivationInfo() {
    _setProductsActivationInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var mockedApi, crossActivation, getProductsActivationInfo, info, noStatusReceived;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              mockedApi = features && features.mockActivationApi;
              crossActivation = features && features.crossActivation;
              getProductsActivationInfo = mockedApi ? mockedFetchProductsActivationInfo : fetchProductsActivationInfo;

              if (!crossActivation) {
                _context.next = 18;
                break;
              }

              _context.prev = 4;
              _context.next = 7;
              return getProductsActivationInfo(environment, swicusOrgId);

            case 7:
              info = _context.sent;
              setNewProductsStatus(info.products);
              _context.next = 16;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](4);
              noStatusReceived = generateStatusForAllProducts(PRODUCT_STATUS.NO_STATUS);
              setNewProductsStatus(noStatusReceived); // eslint-disable-next-line no-console

              console.error(_context.t0);

            case 16:
              _context.next = 19;
              break;

            case 18:
              setNewProductsStatus(generateStatusForAllProducts(PRODUCT_STATUS.CAN_SWITCH));

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[4, 11]]);
    }));
    return _setProductsActivationInfo.apply(this, arguments);
  }

  function setNewProductsStatus(productsStatus) {
    productsStatus[currentProduct] = PRODUCT_STATUS.CURRENT_PRODUCT;
    setProductsStatus(productsStatus);
  }
};
export default AppSwitcherContent;